import { useEffect, useRef } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { PageContainer, PageHeader } from '@/components/page';
import { Button } from '@/components/ui/button';
import { useDocumentTitle } from '@/lib/hooks';
import { StandaloneLayout } from './standalone-layout';

/** Root error boundary of the router, shown outside the app shell. Focus moves to its title on mount. */
export function RouteError() {
  const error = useRouteError();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unexpected error';
  useDocumentTitle('Something went wrong');
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => heading.current?.focus(), []);
  return (
    <StandaloneLayout>
      <PageContainer>
        <PageHeader
          title="Something went wrong"
          headingRef={heading}
          description="The page could not be shown."
        />
        <p className="max-w-prose break-words rounded-sm border border-border bg-sunken px-3 py-2 font-mono text-xs text-text">
          {message}
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Reload
          </Button>
          <Button asChild variant="primary">
            <Link to="/">Go to your servers</Link>
          </Button>
        </div>
      </PageContainer>
    </StandaloneLayout>
  );
}
